<template>
  <generic-modal
    size
    :title="$t('send sms')"
    icon="envelope"
    image="/images/icons/sms.png"
    v-bind:scrolling="false"
    v-on:destroy="destroy"
    v-bind:on_finished="this.finished"
  >
    <div class="description">
      <div class="ui form" ref="form">
        <div class="two fields">
          <div class="field">
            <label for>{{ $t("programed send") }}</label>
            <div class="ui calendar" ref="send_date">
              <div class="ui input left icon">
                <i class="calendar icon"></i>
                <input type="text" v-bind:placeholder="$t('select date')" />
              </div>
            </div>
          </div>
          <div class="field">
            <label for>{{ $t("template") }}</label>
            <div class="ui selection dropdown" ref="template_dropdown">
              <input type="hidden" name="type" />
              <i class="dropdown icon"></i>
              <div class="default text">{{ $t("select one") }}</div>
              <div class="menu"></div>
            </div>
          </div>
        </div>

        <div class="field">
          <label for>{{ $t("message") }}</label>
          <textarea name="message" rows="2" v-model="message"></textarea>
        </div>
        <div class="ui error message"></div>
      </div>
    </div>
  </generic-modal>
</template>

<script>
import { local_api, error_toast } from "@/utils";
import GenericModal from "@/components/GenericModal";

export default {
  components: {
    "generic-modal": GenericModal
  },
  computed: {},
  props: { customer: Object, phone: Object, sms: Object },
  data() {
    return {
      message: "",
      date() {
        let dt = window.jQuery(this.$refs.send_date).calendar("get date");
        return dt;
      }
    };
  },
  methods: {
    finished() {
      let vm = this;
      return new Promise(function(resolve, reject) {
        let isValid = window.jQuery(vm.$refs.form).form("validate form");

        if (!isValid) reject();
        else {
          local_api(vm, "post", "/customer_phone_sms/do-save", {
            i: vm.sms ? vm.sms.uuid : undefined,
            p: vm.phone.phone_id,
            d: vm.date(),
            m: vm.message
          })
            .then((sms) => {
              vm.$emit("succedded", sms);
              resolve();
            })
            .catch((err) => {
              reject(err);
            });
        }
      });
    },
    destroy() {
      this.$emit("destroy");
      this.$destroy();
    }
  },
  mounted() {
    let vm = this;
    local_api(vm, "post", "/customer_phone/do-get-configuration")
      .then((conf) => {
        if (conf && conf.setup) {
          let vls = conf.setup.templates.map((t) => {
            return { value: t.id, name: t.name };
          });
          window
            .jQuery(this.$refs.template_dropdown)
            .dropdown("setup menu", { values: vls })
            .dropdown({
              // eslint-disable-next-line no-unused-vars
              onChange(value, text, $element) {
                let src = conf.setup.templates.find((t) => t.id == value);
                if (src) vm.message = src.template;
              }
            });
        }
      })
      .catch((err) => {
        error_toast(this.$el, "error", err);
      });

    window.jQuery(vm.$refs.send_date).calendar({
      today: true
    });
  },
  watch: {},
  updated: function() {
    this.$nextTick(function() {});
  }
};
</script>
